import MapApp from '@/pages/map';
import FavoritesApp from '@/pages/favorites';
import ForestGamesApp from '@/pages/forest-games';
import RouteApp from '@/pages/route';
import DestinationApp from '@/pages/destination';

export class Api {
    public static Destinations: any[];
}

export namespace Pages {
    export class Map {
        public app(selector: string) {
            return new MapApp({el: selector});
        }
    }

    export class Route {
        public app(selector: string) {
            return new RouteApp({el: selector});
        }
    }

    export class Destination {
        public app(selector: string) {
            return new DestinationApp({el: selector});
        }
    }

    export class Favorites {
        public app(selector: string) {
            return new FavoritesApp({el: selector});
        }
    }

    export class ForestGames {
        public app(selector: string) {
            return new ForestGamesApp({el: selector});
        }
    }
}
